<div>
  <i class="avc-check-circle" *ngIf="payment?.paid"></i>
  <i class="avc-cross-circle" *ngIf="payment?.error"></i>
  <span class="checkin__payment__detail__text">{{ payment?.text }}</span>
  <span [ngClass]="{'checkin__payment__detail__date': payment?.momentoPago !== 'ante', 'checkin__payment__detail__text': payment?.momentoPago === 'ante'}">
    {{ payment?.momentoPago === 'ante' ? removeParentheses(payment?.date) : payment?.date }}
  </span>
</div>
<span class="checkin__payment__detail__amount">{{ payment?.amount | formatCurrency:payment?.currency }}</span>
<div *ngIf="payment?.selected" class="checkin__payment__detail__selected" [ngClass]="{ 'error': payment?.error }"></div>
